/**
 * Progreso en el resumen de la campaña (3/11, B4), sin React (progresoResumen.test.js).
 */

/**
 * La etiqueta de una persona con cita abierta: «Con cita · 4/11» si la cita lleva progreso (el
 * servidor manda `cita.progreso` = { hechas, total } sólo en citas abiertas de campañas con
 * subtareas); si no, «Reservada» o «Confirmada», como antes.
 */
export function etiquetaConCita(usuario) {
  const p = usuario?.cita?.progreso;
  if (p && p.total > 0) return `Con cita · ${p.hechas}/${p.total}`;
  return usuario?.cita?.estado === 'confirmada' ? 'Confirmada' : 'Reservada';
}

/**
 * La carga de un técnico, partida: «en curso» (abiertas con alguna subtarea marcada) y «sin
 * empezar». Con un servidor anterior al 3/11 (sin esos campos) todas las abiertas cuentan como
 * «sin empezar», que es lo que se leía como «pendientes».
 */
export function cargaTecnico(carga = {}) {
  const enCurso = Number(carga.en_curso) || 0;
  const sinEmpezar = carga.sin_empezar != null ? Number(carga.sin_empezar) || 0 : Number(carga.reservadas) || 0;
  const realizadas = Number(carga.realizadas) || 0;
  const noAsistio = Number(carga.no_asistio) || 0;
  const canceladas = Number(carga.canceladas) || 0;
  return { enCurso, sinEmpezar, realizadas, noAsistio, canceladas, total: enCurso + sinEmpezar + realizadas + noAsistio + canceladas };
}
